interface ArticleSchema {
  headline: string;
  description: string;
  author: string;
  datePublished: string;
  dateModified: string;
  image?: string;
}

interface FAQItem {
  question: string;
  answer: string;
}

interface SchemaOrgProps {
  type: 'WebSite' | 'WebPage' | 'Article' | 'BreadcrumbList' | 'FAQPage' | 'Organization';
  name?: string;
  description?: string;
  url?: string;
  article?: ArticleSchema;
  faqItems?: FAQItem[];
  breadcrumbItems?: { name: string; url: string }[];
}

export default function SchemaOrg({
  type,
  name,
  description,
  url,
  article,
  faqItems,
  breadcrumbItems,
}: SchemaOrgProps) {
  let schema: Record<string, unknown>;

  switch (type) {
    case 'WebSite':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: name || '韩漫网',
        url: url || 'https://hanman.readdy.ai',
        description: description || '韩漫网是免费韩漫大全平台，汇聚热门韩国漫画在线阅读资源',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: 'https://hanman.readdy.ai/search?q={search_term_string}',
          },
          'query-input': 'required name=search_term_string',
        },
      };
      break;

    case 'WebPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: name,
        description: description,
        url: url,
        isPartOf: {
          '@type': 'WebSite',
          name: '韩漫网',
          url: 'https://hanman.readdy.ai',
        },
      };
      break;

    case 'Article':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: article?.headline || '',
        description: article?.description || '',
        image: article?.image,
        author: {
          '@type': 'Person',
          name: article?.author || '',
        },
        datePublished: article?.datePublished || '',
        dateModified: article?.dateModified || '',
        publisher: {
          '@type': 'Organization',
          name: '韩漫网',
        },
      };
      break;

    case 'FAQPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: (faqItems || []).map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      };
      break;

    case 'BreadcrumbList':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: (breadcrumbItems || []).map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.name,
          item: item.url,
        })),
      };
      break;

    case 'Organization':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '韩漫网',
        url: 'https://hanman.readdy.ai',
        description: '韩漫网是免费韩漫大全平台，汇聚热门韩国漫画在线阅读资源',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'contact@hanman.readdy.ai',
          contactType: 'customer service',
        },
      };
      break;

    default:
      schema = {};
  }

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
}